<template>
  <div>
    <b-card sub-title="Members Details (Name,Age,Samibagh Id Card)">
      <div v-for="(v, index) in $v.members.$each.$iter" :key="index">
        <hr v-if="index > 0" class="members-row"/>
        <b-row >
          <b-col lg="4"><b-form-input type="text" class="form-control" v-model="v.i_card_number.$model" :state="chkState('i_card_number', index)" placeholder="Soamibagh I-Card number (Write NA if you don't have ID Card)" @change="changeIdCardNo(index)"></b-form-input></b-col>
          <b-col lg="4"><b-form-input type="text" class="form-control" v-model="v.name.$model" :state="chkState('name', index)" placeholder="Name"></b-form-input></b-col>
          <b-col lg="4"><b-form-input type="number" class="form-control" v-model="v.age.$model" :state="chkState('age', index)" placeholder="Age"></b-form-input></b-col>
        </b-row>
      </div>
    </b-card>

    <div class="alert alert-danger" v-if="!$v.members.required && $v.members.$dirty">Please provide at least one member</div>
  </div>

</template>

<script>
import Vue from 'vue'

import {
  required
} from "vuelidate/lib/validators"

export default {
  name: 'MemberList',
  computed: {
    isValid() {
      return !this.$v.members.$anyError
    },
    isDirty() {
      return this.$v.members.$anyDirty
    }
  },
  data: function () {
    return {
      total: 0,
      members: []
    };
  },
  validations: {
    members: {
      required,
      $each: {
        name: {
          required,
        },
        age: {
          required
        },
        i_card_number: {
          required
        }
      }
    }
  },
  methods: {
    changeIdCardNo(index) {
      let value = this.members[index]['i_card_number']

      if (value != 'NA') {
        this.$store.dispatch('customers/getCustomer', {id_card_no: value})
        .then((customer) => {
          if (customer) {
            this.members[index].name = customer.main_name
            this.members[index].age = Math.floor(this.$moment(new Date()).diff(this.$moment(customer.dob),'years',true))
          }
        })
      }
    },
    addMember() {
      this.members.push({name: "", age: "", i_card_number: ""})
    },
    removeMember() {
      this.members.pop()
    },
    getMembers() {
      return this.members
    },
    setMember(customer) {
      let age = Math.floor(this.$moment(new Date()).diff(this.$moment(customer.dob),'years',true))
      this.onReset()
      this.members.push({name: customer.main_name, age: age, i_card_number: customer.id_card_no})
    },
    onReset() {
      this.members = []
      this.$nextTick(() => {
        this.$v.$reset()
      })
    },
    chkState(val, index) {
      const field = this.$v.members.$each[index][val]
      return field.$dirty ? !field.$invalid : null
    },
    findFirstError(component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate() {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    }
  },
  created() {

  },
}
</script>

<style>
.members-row {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>
